import React from 'react'
import { DashMain } from './styles'
import MobileMenu from '../../components/MobileMenu'

function Dashboard() {
  return (
    <>
      <DashMain>
        <MobileMenu />
      </DashMain>
    </>
  )
}

export default Dashboard
